import { u_ } from "@pressmedia/webappbase";

export default {
	/*----------------
	* サーバーリクエスト用のフィルターオブジェクトを生成
	* @return array
	*/
	createConditions(fltr) {
		const arr = [];
		
		if( u_.isObject(fltr) && u_.isObject(this.searchParams) ) {
			if(
				this.keywordQuery !== "KEYWORD" &&
				u_.hasProperty(fltr, this.keywordQuery)
			) {
				fltr.KEYWORD = fltr[this.keywordQuery];
				delete fltr[this.keywordQuery];
			}
			
			Object.keys(this.searchParams).forEach(k => {
				const srchPi = this.searchParams[k];
				const cond = {
					targetParam: k
				};
				
				if(k === "KEYWORD") {
					if( u_.hasProperty(fltr, k) ) {
						cond.condition = "like";
						cond.value = fltr[k];
						arr.push(cond);
					}
					return true;
				}
				
				let v;
				
				// データの種類ごとに処理を分岐
				switch(srchPi.inpType) {
					case "period": {
						v = "";
						// from
						if( u_.hasProperty(fltr, `${k}_from`) ) {
							// date, datetime
							v = fltr[`${k}_from`];
						} else {
							if( u_.hasProperty(fltr, `${k}_s_from`) ) {
								let value = `s,${fltr[`${k}_s_from`]}`;
								(value.indexOf("T") < 0) && (value += "T00:00");
								arr.push({
									condition: "gte",
									value,
									...cond
								});
							}
							
							if( u_.hasProperty(fltr, `${k}_e_from`) ) {
								v = `e,${fltr[`${k}_e_from`]}`;
							}
						}
						
						if(v) {
							(v.indexOf("T") < 0) && (v += "T00:00");
							arr.push({
								condition: "gte",
								value: v,
								...cond
							});
							v = "";
						}
						
						// to
						if( u_.hasProperty(fltr, `${k}_to`) ) {
							v = fltr[`${k}_to`];
						} else {
							if( u_.hasProperty(fltr, `${k}_s_to`) ) {
								let value = `s,${fltr[`${k}_s_to`]}`;
								(value.indexOf("T") < 0) && (value += "T23:59");
								arr.push({
									condition: "lte",
									value,
									...cond
								});
							}
							
							if( u_.hasProperty(fltr, k + "_e_to") ) {
								v = `e,${fltr[`${k}_e_to`]}`;
							}
						}
						
						if(v) {
							(v.indexOf("T") < 0) && (v += "T23:59");
							cond.condition = "lte";
						}
						
						break;
					}
					
					case "date":
					case "datetime": {
						if( u_.hasProperty(fltr, k) ) {
							v = fltr[k];
							cond.condition = "eq";
							
							if(
								this.config.dataParams[k] &&
								this.config.dataParams[k].inpType === "datetime" &&
								v.indexOf("T") < 0
							) {
								cond.condition = "in";
							}
						}
						break;
					}
					
					case "checkbox": {
						if( u_.hasProperty(fltr, k) ) {
							v = fltr[k];
							if(v === "") {
								v = "NULL";
								cond.condition = "eq";
							} else {
								cond.condition = "in";
							}
						}
						break;
					}
					
					case "radio": {
						if( u_.hasProperty(fltr, k) ) {
							v = fltr[k];
							if(v === "") {
								v = "NULL";
								cond.condition = "eq";
							} else
							if( !u_.isNumber(srchPi.optLength) ) {
								cond.condition = "in";
							} else {
								v = v.split(",").length;
								if(v < srchPi.optLength) {
									cond.condition = (v === 1) ? "eq" : "in";
								}
								v = fltr[k];
							}
						}
						break;
					}
					
					case "flg": {
						if( u_.hasProperty(fltr, k) && fltr[k].indexOf(",") < 0 ) {
							v = parseInt(fltr[k]);
							cond.condition = "eq";
						}
						break;
					}
					
					case "number": {
						if( u_.hasProperty(fltr, k) ) {
							v = parseFloat(fltr[k]);
							cond.condition = "eq";
						}
						break;
					}
					
					default: {
						if( u_.hasProperty(fltr, k) ) {
							v = fltr[k];
							cond.condition = "eq";
						}
						break;
					}
				}
				
				if(cond.condition) {
					cond.value = v;
					arr.push(cond);
				}
			});
		}
		
		return arr;
	}
}
